import { SuperAdminNotificationsState } from './types';

export const initialState: SuperAdminNotificationsState = {
  superAdminNotifications: [],
  superAdminNotificationsLoading: true,
};
